const Pamphlets = (target) => {
  const loadMoreBtn = target.querySelector(".docs__loadmore button");
  const innerContainer = target.querySelector(".docs__innercontainer");

  const method = {
    init: () => {
      loadMoreBtn.addEventListener("click", method.loadMore);
    },
    loadMore: (e) => {
      e.preventDefault();
      innerContainer.classList.remove("docs__init");
      e.target.parentElement.classList.add("docs__loadmore--hide");
    },
  };

  method.init();
};

export default Pamphlets;
